// no need to write one yourself, you can find them here: https://github.com/Rich-Harris/eases-jsnext/blob/master/src
export const easings = {
  linear(t) {
    return t;
  },
  cubicInOut(t) {
    return t < 0.5 ? 4.0 * t * t * t : 0.5 * (2.0 * t - 2.0) ** 3.0 + 1.0;
  },
  quintOut(t) {
    return --t * t * t * t * t + 1;
  },
  quadIn(t) {
    return t * t;
  },
};

export function interpolate(from, to, progress) {
  const delta = to - from;
  return from + progress * delta;
}

function applyStyle(element, styles, _tween) {
  for (const key in styles) {
    if (Object.prototype.hasOwnProperty.call(styles, key)) {
      const value = styles[key];
      element.style[key] = value(_tween);
    }
  }
}

export function tween({
  from = 0,
  to = 1,
  duration = 1000,
  easing = easings.linear,
  delay = 0,
  onUpdate,
  onComplete,
} = {}) {
  const start = performance.now() + delay;

  const update = (current) => {
    const elapsed = current - start;
    const progress = Math.max(Math.min(elapsed / duration, 1), 0);
    const latest = interpolate(from, to, easing(progress));

    if (onUpdate) onUpdate(latest);

    if (progress < 1) {
      requestAnimationFrame(update);
    } else if (onComplete) onComplete();
  };

  setTimeout(() => {
    requestAnimationFrame(update);
  }, delay);
}

export function animate({
  targets,
  styles,
  duration,
  easing,
  delay = 0,
  direction = 'normal',
  stagger,
  onComplete,
} = {}) {
  const elements = typeof targets === 'string' ? Array.from(document.querySelectorAll(targets)) : targets;

  if (stagger) {
    let staggerDelay = 0;
    let completedAnimations = 0;
    elements.forEach((element) => {
      applyStyle(element, styles, direction === 'reverse' ? 1 : 0);
      tween({
        duration,
        easing: easings[easing],
        delay: staggerDelay,
        onUpdate: (v) => {
          const value = direction === 'reverse' ? 1 - v : v;
          applyStyle(element, styles, value);
        },
        onComplete: () => {
          completedAnimations++;
          if (completedAnimations === elements.length && onComplete) onComplete();
        },
      });
      staggerDelay += stagger;
    });
    return;
  }

  // reset styles to beginning of animation
  elements.forEach((element) => {
    applyStyle(element, styles, direction === 'reverse' ? 1 : 0);
  });

  tween({
    duration,
    easing: easings[easing],
    delay,
    onUpdate: (v) => {
      const value = direction === 'reverse' ? 1 - v : v;
      elements.forEach((element) => {
        applyStyle(element, styles, value);
      });
    },
    onComplete,
  });
}

window.tween = tween;
window.easings = easings;
window.animate = animate;
